import Axios from "./utils/axios";

/** Unique instance; lives outside of `index.tsx` so that the router loaders do not depend on the entry (avoids TDZ / cycles with `createBrowserRouter`). */
export const axios = new Axios();
